export enum PdfSettingsDiscountUnitEnum {
  PERCENT = 'PERCENT',
  AMOUNT = 'AMOUNT',
}
